import heroImage from "../assets/images/heroimage.svg";
import heroImagetwo from "../assets/images/heroimagetwo.svg";
import "../assets/css/landingpage.css";
import Modal from "../component/Modal";
import { useRef, useState } from "react";
import FaqSection from "../component/Faq";
import POLICY from "../files/KPMG Whistleblowing Policy.pdf";
import FAQ from "../files/Frequently Asked Questions (FAQs) on Whistleblowing.pdf";
import ConfirmModal from "../component/confirmModal";

export default function LandingPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isConfirModalOpen, setIsConfirmModalOpen] = useState(true);
  const sectionRef = useRef();
  const scrollToFAQ = () => {
    sectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const closeConfirmModal = () => {
    setIsConfirmModalOpen(false);
  };

  const handleHotlinkClick = (event) => {
    event.preventDefault(); // Prevent the default behavior of the link
    openModal(); // Call the function to open the modal
  };
  return (
    <div className="app">
      {/* Hero */}
      <div className=" container-fluid px-3 px-lg-5 ">
        <div className="row align-items-top ">
          <div className="col-md-6">
            <div className="hero-content">
              <h1 className="heading">
                Welcome to the <span>KPMG</span> Speak Up Portal
                (WhistleBlowing)
              </h1>
              <p className="desc">
                Acting with integrity is at the heart of our values and we all
                need to make the right decision by speaking up!!!
              </p>
              <div className="mt-4 mb-4 pt-2 mx-auto d-flex hero-button">
                <button onClick={openModal} className="btn btn-1">
                  Make a Report
                </button>
                <a href="#" onClick={scrollToFAQ} className="btn btn-2">
                  View FAQs
                </a>
              </div>
            </div>
          </div>
          <div className="col-md-5">
            <div className="hero-image">
              <img src={heroImage} alt="heroImage" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
      {/* New Section */}
      <div className="list">
        <p className="list-heading">The available reporting channels are...</p>
        <div className="row px-2 px-lg-5 gap-4 gap-lg-0">
          <div className="col-md-4">
            <div className="list-content h-100">
              <p className="heading">"Complaint Boxes”</p>
              <ul>
                <li className="texts">Right Wing, First Floor </li>
                <li className="texts">Left Wing, Upper Ground</li>
                <li className="texts">The Security post</li>
              </ul>
            </div>
          </div>
          <div className="col-md-4 ">
            <div className="list-content h-100 ">
              <p className="heading">“Hotlink”</p>
              <ul>
                <li>
                  <a href="#" onClick={handleHotlinkClick} className="texts">
                    Our Local Hotlink
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-4">
            <div className="list-content">
              <p className="heading">“Hotmail & Hotlines”</p>
              <ul>
                <li>
                  <a
                    href="mailto:NG-FMKPMGWhistleBlowing@ng.kpmg.com"
                    className="texts"
                  >
                    Hotmail
                  </a>
                </li>
                <li>
                  <a
                    href="https://kpmg.com/xx/en/home/campaigns/2018/01/kpmg-international-hotline.html"
                    className="texts"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Our International Hotline
                  </a>
                </li>
                {/* <li className="texts">
                  Nigeria Hotline number{" "}
                  <span style={{ fontWeight: "bold" }}>-0800-WHISTLE </span>
                  <span style={{ fontWeight: "bold" }}>(08009447853)</span>.
                  Note that this number is toll free from all networks in
                  Nigeria.
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Fourth section */}
      <div className="report-section ">
        <div className="container-fluid px-3 px-lg-5 ">
          <div className="row align-items-center">
            <div className="col-md-5 ">
              <h2 className="">Why Should I Report?</h2>
              <div>
                <p className="custom-paragraph text-line-height">
                  KPMG recognises and understands that reporting a concern can
                  be very difficult, especially where it relates to a superior
                  or business associate. However, if what is to be reported
                  represents the correct position of things in the honest belief
                  of the whistle-blower, there is absolutely nothing to worry
                  about, as the firm will consider such report as a great
                  service which enhances integrity and equity in its internal
                  processes and protects its brand image. <br />
                  Please refer to the{" "}
                  <a
                    href={POLICY}
                    download="KPMG Whistleblowing Policy.pdf"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Whistle Blowing Policy
                  </a>{" "}
                  for more information.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <img src={heroImagetwo} alt="heroImage" className="img-fluid" />
            </div>
          </div>
        </div>
      </div>
      <div className="list">
        <div className=" px-2 px-lg-5  text-line-height">
          <p>
            Persons who Speak Up should be assured that KPMG will not tolerate
            any <b>harrassment</b> or <b>victimisation</b> whatsoever and
            howsoever arising, including but not limited to informal pressures,
            and will take appropriate actions and measures to protect such
            persons, to the fullest extent permitted by applicable laws, when a
            concern in good faith is raised. All reports of potential misconduct
            and investigations are dealt with confidentially, to the extent
            allowable by law and professional standards, and consistent with the
            needs of a thorough investigation and appropriate remediation. No
            retaliation is taken against individuals who have reported matters
            in good faith – even if the allegations or some elements of them
            prove to be unfounded.
          </p>
        </div>
      </div>
      <Modal isOpen={isModalOpen} onClose={closeModal} />
      <ConfirmModal isOpen={isConfirModalOpen} onProceed={closeConfirmModal} />
      <div ref={sectionRef} id="faq-section">
        <FaqSection />
      </div>
    </div>
  );
}
